export const safeShowPopover = (element?: HTMLElement) => {
  try {
    element?.showPopover();
  } catch (e) {
    console.warn(e);
  }
};

export const safeHidePopover = (element?: HTMLElement) => {
  try {
    element?.hidePopover();
  } catch (e) {
    console.warn(e);
  }
};
